import styled from '@emotion/styled';
import { useTranslation } from 'react-i18next';
import { MIN_SEARCH_TERM_LENGTH } from './InviteUser';

interface Props {
  onlineUsersCount?: number;
  searchedTerm?: string | null;
}

const OnlineUsersText = ({ onlineUsersCount, searchedTerm }: Props) => {
  const [t] = useTranslation();

  let onlineCountText;

  if (searchedTerm && searchedTerm.length >= MIN_SEARCH_TERM_LENGTH) {
    onlineCountText =
      onlineUsersCount != null
        ? t('lobby.foundUsersCount', 'Nalezeno {{count}} kolegů online', {
            count: onlineUsersCount,
          })
        : t('lobby.foundUsersCountLoading', 'Nenalezen žádný kolega online');
  } else {
    onlineCountText =
      onlineUsersCount != null
        ? t('lobby.onlineUsersCount', '{{count}} kolegů je online', {
            count: onlineUsersCount,
          })
        : t('lobby.onlineUsersCountLoading', '- kolegů je online');
  }

  return <UsersText>{onlineCountText}</UsersText>;
};

export default OnlineUsersText;

const UsersText = styled.div`
  margin-top: 4px;
  font-size: 0.75rem;
  color: #9593ae;
  letter-spacing: 0;
  text-align: center;
  line-height: 2.2;
  text-transform: uppercase;
`;
